import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, SlidersHorizontal } from 'lucide-react';
import CarriersCard from '../components/shipments/CarriersCard';
import ErrorsCard from '../components/shipments/ErrorsCard';
import MailboxesCard from '../components/shipments/MailboxesCard';
import SettingsForm from '../components/shipments/SettingsForm';
import { EnvCard, WorkerCard } from '../components/shipments/StatusCards';
import { Banner, SkeletonBlock } from '../components/shipments/Ui';
import { useRemote } from '../components/shipments/useRemote';
import { useToasts } from '../components/shipments/useToasts';
import { shipmentsApi } from '../utils/shipmentsApi';

// Module settings (admins who passed the gate): mailboxes, thresholds with validation, environment, worker, errors, carriers.
const ShipmentsSettings = () => {
  const { notify, host } = useToasts();
  const settings = useRemote('settings', () => shipmentsApi.settings());
  const data = settings.data;

  return (
    <div className="shp-page" style={{ maxWidth: 1100 }}>
      {host}
      <Link to="/zasilky" className="shp-textbtn" style={{ textDecoration: 'none', marginBottom: 12 }}><ArrowLeft size={16} aria-hidden="true" /> Zpět na zásilky</Link>
      <header className="shp-head">
        <h1 className="shp-title"><SlidersHorizontal color="#E53935" aria-hidden="true" /> Nastavení zásilek</h1>
      </header>

      {settings.error && (
        <Banner tone="bad" action={<button type="button" className="shp-textbtn" onClick={settings.reload}>Zkusit znovu</button>}>
          Nastavení se nepodařilo načíst. {settings.error.message}
        </Banner>
      )}
      {!data && !settings.error && <div className="shp-stack"><SkeletonBlock height={140} /><SkeletonBlock height={220} /></div>}

      {data && (
        <div className="shp-stack">
          {/* true = fine, false = the worker reports missing credentials (warning), null = unknown yet (neutral, no banner) */}
          {data.env?.googleConfigured === false && (
            <Banner tone="warn">
              Worker hlásí, že chybí přístupový klíč ke Gmailu (Google credentials missing), takže synchronizace pošty neběží.
              Soubor s klíčem Google musí správce nahrát na server.
            </Banner>
          )}
          <WorkerCard worker={data.worker} aiUsage={data.aiUsage} limit={data.env?.aiDailyLimitFromEnv ?? data.settings?.aiDailyLimit} />
          <MailboxesCard mailboxes={data.mailboxes || []} allowed={data.env?.allowedMailboxes ?? []} onChanged={settings.reload} notify={notify} />
          <section className="shp-card" aria-labelledby="shp-settings-title">
            <h2 id="shp-settings-title" className="shp-h2">Pravidla zpracování</h2>
            <SettingsForm
              key={JSON.stringify([data.settings, data.env?.aiDailyLimitFromEnv ?? null])} settings={data.settings}
              aiLimitFromEnv={data.env?.aiDailyLimitFromEnv ?? null} notify={notify}
              onSaved={(payload) => settings.mutate(() => payload)}
            />
          </section>
          <CarriersCard notify={notify} />
          <EnvCard env={data.env} />
          <ErrorsCard notify={notify} />
        </div>
      )}
    </div>
  );
};

export default ShipmentsSettings;
